(() => {
  const init = root => root.querySelectorAll('[data-pp-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const row = gallery.querySelector('[data-pp-gallery-row]');
    const slides = [...row.children];
    const thumbs = [...gallery.querySelectorAll('[data-pp-gallery-thumb]')];
    const strip = gallery.querySelector('[data-pp-gallery-strip]');
    const thumbRow = gallery.querySelector('[data-pp-gallery-thumbs]');
    const arrows = [...strip.querySelectorAll('[data-pp-gallery-step]')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const compact = matchMedia('(max-width: 1099.98px)');
    let selected = 0;
    let aiming = false;
    let settleTimer;
    let layoutWidth = row.clientWidth;
    const mark = index => {
      selected = index;
      thumbs.forEach((button, position) => button.setAttribute('aria-current', String(position === index)));
      arrows[0].setAttribute('aria-disabled', String(index === 0));
      arrows[1].setAttribute('aria-disabled', String(index === slides.length - 1));
      if (!compact.matches) return;
      const thumbStart = thumbs[index].offsetLeft - thumbs[0].offsetLeft;
      if (thumbStart < thumbRow.scrollLeft) thumbRow.scrollLeft = thumbStart;
      else if (thumbStart + thumbs[index].offsetWidth > thumbRow.scrollLeft + thumbRow.clientWidth) thumbRow.scrollLeft = thumbStart + thumbs[index].offsetWidth - thumbRow.clientWidth;
    };
    const select = (index, focus = false, instant = false) => {
      index = Math.max(0, Math.min(slides.length - 1, index));
      aiming = true;
      clearTimeout(settleTimer);
      if (compact.matches) row.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: instant || reduced.matches ? 'instant' : 'smooth'});
      mark(index);
      settleTimer = setTimeout(() => { aiming = false; }, 700);
      if (focus) thumbs[index].focus({preventScroll: true});
    };
    const fit = () => {
      if (!compact.matches) thumbRow.style.removeProperty('width');
      else {
        const count = Math.max(1, Math.min(thumbs.length, Math.floor((strip.clientWidth - 104 + 8) / 56)));
        thumbRow.style.width = (count * 56 - 8) + 'px';
      }
      if (compact.matches && row.clientWidth !== layoutWidth) select(selected, false, true);
      layoutWidth = row.clientWidth;
      mark(selected);
    };
    strip.hidden = false;
    thumbs.forEach((button, index) => {
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        const next = event.key === 'ArrowRight' ? (index + 1) % slides.length : event.key === 'ArrowLeft' ? (index + slides.length - 1) % slides.length : event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : null;
        if (next === null) return;
        event.preventDefault(); select(next, true);
      });
    });
    arrows.forEach(button => button.addEventListener('click', () => { if (button.getAttribute('aria-disabled') === 'true') return; select(selected + Number(button.dataset.ppGalleryStep)); }));
    row.addEventListener('scroll', () => {
      if (aiming || !compact.matches) return;
      const index = slides.reduce((best, slide, position) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - row.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - row.scrollLeft) ? position : best, 0);
      mark(index);
    }, {passive: true});
    row.addEventListener('touchstart', () => { aiming = false; clearTimeout(settleTimer); }, {passive: true});
    row.addEventListener('pointerdown', () => { aiming = false; clearTimeout(settleTimer); });
    row.addEventListener('wheel', () => { aiming = false; clearTimeout(settleTimer); }, {passive: true});
    new ResizeObserver(fit).observe(gallery);
    fit();
    const dialog = gallery.querySelector('[data-pp-gallery-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const zooms = [...gallery.querySelectorAll('[data-pp-gallery-zoom], [data-pp-gallery-zoom-video]')];
    const viewer = dialog.querySelector('[data-pp-gallery-viewer]');
    const image = dialog.querySelector('img');
    const film = viewer.querySelector('video');
    const dots = dialog.querySelector('[data-pp-gallery-dots]');
    const modalArrows = [...dialog.querySelectorAll('[data-pp-lightbox-step]')];
    let imageIndex = 0;
    let opener;
    let scrollPosition = 0;
    let bodyStyles;
    let touchStart = null;
    let drag = null;
    let wheelSum = 0;
    let wheelQuiet = 0;
    let wheelLast = 0;
    const settle = () => { touchStart = null; drag = null; wheelSum = 0; wheelQuiet = 0; wheelLast = 0; };
    const showImage = index => {
      imageIndex = Math.max(0, Math.min(zooms.length - 1, index));
      const source = zooms[imageIndex];
      const clip = film && source.hasAttribute('data-pp-gallery-zoom-video') ? source.closest('[data-pp-video]')?.querySelector('video') : null;
      film?.pause();
      image.hidden = Boolean(clip);
      if (film) film.hidden = !clip;
      if (clip) {
        if (!film.dataset.ppReady) {
          film.dataset.ppReady = 'true';
          clip.querySelectorAll('source').forEach(node => film.append(node.cloneNode()));
          if (clip.poster) film.poster = clip.poster;
          film.style.setProperty('--sap-pp-zoom-ratio', Number(source.dataset.ratio) || 1);
        }
        film.setAttribute('aria-label', source.dataset.alt);
      } else {
        image.src = source.dataset.image;
        image.alt = source.dataset.alt;
      }
      [...dots.children].forEach((dot, position) => dot.setAttribute('aria-current', String(position === imageIndex)));
      modalArrows[0].setAttribute('aria-disabled', String(imageIndex === 0));
      modalArrows[1].setAttribute('aria-disabled', String(imageIndex === zooms.length - 1));
    };
    zooms.forEach((button, index) => {
      button.hidden = false;
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', thumbs[slides.indexOf(button.closest('[data-pp-gallery-slot]'))].getAttribute('aria-label'));
      dot.addEventListener('click', () => showImage(index));
      dots.append(dot);
      if (button.hasAttribute('data-pp-gallery-zoom-video')) return;
      button.addEventListener('click', () => {
        opener = button;
        showImage(index);
        scrollPosition = window.scrollY;
        bodyStyles = ['position', 'top', 'left', 'right', 'overflow'].map(property => [property, document.body.style.getPropertyValue(property), document.body.style.getPropertyPriority(property)]);
        Object.assign(document.body.style, {position: 'fixed', top: '-' + scrollPosition + 'px', left: '0', right: '0', overflow: 'hidden'});
        settle();
        dialog.showModal();
        dialog.querySelector('[data-pp-gallery-close]').focus({preventScroll: true});
      });
    });
    modalArrows.forEach(button => button.addEventListener('click', () => { if (button.getAttribute('aria-disabled') === 'true') return; showImage(imageIndex + Number(button.dataset.ppLightboxStep)); }));
    dialog.querySelector('[data-pp-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      // Keys on the video and its native controls seek; they never change the slide.
      if (film && event.target === film) return;
      event.preventDefault();
      showImage(imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    // Mouse and pen drag (touch keeps its own handler below); a press on the video's control bar scrubs instead.
    viewer.addEventListener('dragstart', event => event.preventDefault());
    viewer.addEventListener('pointerdown', event => {
      drag = null;
      if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0) return;
      if (event.target === film && event.clientY > film.getBoundingClientRect().bottom - 56) return;
      drag = {x: event.clientX, y: event.clientY, id: event.pointerId};
    });
    dialog.addEventListener('pointerup', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const horizontal = event.clientX - drag.x;
      const vertical = event.clientY - drag.y;
      drag = null;
      if (Math.abs(horizontal) >= 45 && Math.abs(horizontal) > Math.abs(vertical) * 1.5) showImage(imageIndex + (horizontal < 0 ? 1 : -1));
    });
    dialog.addEventListener('pointercancel', () => { drag = null; });
    // Trackpad: one step per sideways gesture; the gesture ends after 160 ms without sideways input, and a part gesture is dropped.
    viewer.addEventListener('wheel', event => {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      const now = event.timeStamp;
      if (now - wheelLast > 160) wheelSum = 0;
      wheelLast = now;
      if (now < wheelQuiet) { wheelQuiet = now + 160; return; }
      wheelSum += event.deltaX;
      wheelQuiet = 0;
      if (Math.abs(wheelSum) < 40) return;
      showImage(imageIndex + (wheelSum > 0 ? 1 : -1));
      wheelSum = 0;
      wheelQuiet = now + 160;
    }, {passive: false});
    // A touch that starts on the video is the shopper using its controls; the gallery arrows still change slides.
    viewer.addEventListener('touchstart', event => {
      touchStart = event.touches.length === 1 && event.target !== film ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
    }, {passive: true});
    dialog.addEventListener('touchcancel', () => { touchStart = null; }, {passive: true});
    dialog.addEventListener('touchend', event => {
      if (!touchStart) return;
      const horizontal = event.changedTouches[0].clientX - touchStart.x;
      const vertical = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(horizontal) >= 45 && Math.abs(horizontal) > Math.abs(vertical) * 1.5) showImage(imageIndex + (horizontal < 0 ? 1 : -1));
    }, {passive: true});
    dialog.addEventListener('close', () => {
      settle();
      film?.pause();
      bodyStyles?.forEach(([property, value, priority]) => value ? document.body.style.setProperty(property, value, priority) : document.body.style.removeProperty(property));
      window.scrollTo({top: scrollPosition, behavior: 'instant'});
      select(slides.indexOf(zooms[imageIndex].closest('[data-pp-gallery-slot]')), false, true);
      opener?.focus({preventScroll: true});
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
